import React from 'react';
import {PageHelmet} from 'components/Pages';
import {truncate} from 'lodash';
import {HELMET_DESC_LIMIT} from 'configs/limits';

function ABHelmet(props) {
  const {data} = props;
  const {
    accreditation_bodies_name,
    accreditation_bodies_acronym,
    accreditation_bodies_desc: abDescription,
    country_name,
  } = data || {};
  const name = [accreditation_bodies_name, accreditation_bodies_acronym]
    .filter((v) => v)
    .join(' - ');

  const truncatedDesc = truncate(abDescription, {length: HELMET_DESC_LIMIT});
  const defaultDesc = `Information about ${name}, ${country_name}, description, list of accredited certification bodies, IAF and national standards and schemes.`;

  const title = `${name} - IAF Accreditation Body`;
  const description = !!abDescription ? truncatedDesc : defaultDesc;

  return <PageHelmet title={title} description={description} />;
}

export default ABHelmet;
